import { NewSmartList, SmartList } from '@griply/types';

import { newSmartListConverter } from './converters/smart-list';
import { addDocumentWithOwnerRole, CollectionOptions } from './helpers';

export const createSmartList = async (
  smartList: NewSmartList,
): Promise<SmartList> => {
  return addDocumentWithOwnerRole(
    CollectionOptions.SmartLists,
    newSmartListConverter(smartList),
  );
};
